import type { Fighter, Scene } from './types';

export const SHOT_SFX: Record<string, string> = { ak: 'shot_ak', m4: 'shot_m4', lmg: 'shot_lmg', awp: 'shot_awp' };

export const BURST: Record<string, { count: number; gap: number }> = {
  awp: { count: 1, gap: 0 },
  rifle: { count: 2, gap: 0.15 },
  lmg: { count: 3, gap: 0.14 },
};

const SECONDS_PER_TICK = 0.01;
const ANIM_STRETCH = 4.8;
export const ROUND_ANIM = 12;
export const playTime = (tick: number) => Math.min(ROUND_ANIM, tick * SECONDS_PER_TICK * ANIM_STRETCH);

export const ENTER_DUR = 0.9;
export const GREN_FLIGHT = 0.5;
export const STANCE_STEP: Record<string, number> = { attack: 0, maneuver: 40, defense: -40 };
export const KNIFE_TRAVEL_FRAC = 0.85;
export const KNIFE_DEATH_FRAC = 0.3;
export const KNIFE_LUNGE = 0.7;

export const now = () => performance.now() / 1000;

export const cull = <T extends { t0: number; life: number }>(list: T[], n: number): void => {
  for (let i = list.length - 1; i >= 0; i--) if (n - list[i].t0 >= list[i].life) list.splice(i, 1);
};

export function nearestEnemyId(sc: Scene, f: Fighter): string | null {
  let best: string | null = null;
  let bestD = Infinity;
  for (const e of sc.fighters) {
    if (e.dead || e.team === f.team) continue;
    const dx = e.x - f.x, dy = e.y - f.y, d = dx * dx + dy * dy;
    if (d < bestD) { bestD = d; best = e.id; }
  }
  return best;
}

const OTHERS_VOL = 0.75;
export type Mix = (base: number, ...involved: (string | undefined | null)[]) => number;
export const createMix = (getYouId: () => string | null): Mix => (base, ...involved) => {
  const you = getYouId();
  return you && involved.includes(you) ? base : base * OTHERS_VOL;
};
